import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { replaceSpaceAndBr } from '@/src/advocacy/utils';
import DesignPage from '@/src/cms/models/DesignPage';
import withForumTermsWrap from '@/src/forum/components/ForumScreenWrap';
import ForumSearchFilters from '@/src/forum/components/ForumSearchFilters';
import ForumThreadList from '@/src/forum/components/ForumThreadList';
import { searchThreads } from '@/src/forum/helper';
import Container from '@/src/shared/components/Container';
import Hero from '@/src/shared/components/Hero';
import Sanitize from '@/src/shared/components/Sanitize';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import request from '@/utils/axios';

const MarketConductForum = props => {
  const { pagedata, messageData = {} } = props;
  const [designPageData, setPageData] = useState(pagedata);
  const [collapsed, setCollapsed] = useState(false);
  const [searching, setSearching] = useState(false);
  const [threadsCount, setCount] = useState(0);
  const [threadsList, setThreadsList] = useState([]);

  useEffect(() => {
    const fetchDesignPage = async () => {
      const pageResponse = await request({
        url: `cms/designpage`,
        params: {
          alias: 'market-conduct-forum',
        },
      });
      if (pageResponse.data?.DateLastUpdated !== pagedata?.DateLastUpdated) {
        setPageData(pageResponse.data);
      }
    };
    fetchDesignPage();
  }, []);

  const page = new DesignPage({ ...designPageData, ...messageData });
  const heroImage =
    page.HeroImageId && `${process.env.NEW_API_URL}image/file?area=c&id=${page.HeroImageId}`;

  const handleSearch = async values => {
    setSearching(true);
    const { count, threads } = await searchThreads(values);
    setCount(count);
    setThreadsList(threads);
    setSearching(false);
  };

  return (
    <>
      <Hero
        title={page.HeroHeadline}
        bgImage={heroImage}
        type="image"
        hideHomePath
        hideInMobile
        hidePaths={['market-conduct']}
      >
        <Sanitize>{replaceSpaceAndBr(page.HeroParagraph)}</Sanitize>
      </Hero>
      <Section bgColor="gray">
        <Container>
          <Row gutter={{ xs: 24, md: 32 }} type="flex">
            <Col xs={24} lg={collapsed ? 24 : 8}>
              <ForumSearchFilters
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                handleSearch={handleSearch}
                searching={searching}
              />
            </Col>
            <Col xs={24} lg={collapsed ? 24 : 16}>
              <ForumThreadList count={threadsCount} threads={threadsList} searching={searching} />
            </Col>
          </Row>
        </Container>
      </Section>
      <WebLogImage path="/compliance/market-conduct/forum" title={page.HeroHeadline} />
    </>
  );
};

export async function getStaticProps() {
  const pageResponse = await request({
    url: `cms/designpage`,
    params: {
      alias: 'market-conduct-forum',
    },
  });
  return {
    props: {
      pagedata: pageResponse.data,
    },
  };
}

export default withForumTermsWrap(MarketConductForum);
